import React from 'react'
export default function () {
  return (
    <div className='text-xs text-center py-2 border-t border-solid border-gray-100'>
      <a target="_blank" href="http://beian.miit.gov.cn" className='text-gray-600 hover:text-blue-600'>备案号：浙ICP备18011593号-1</a>
    </div>
  )
}
